export function createAuthBootstrapService(deps) {
    let state = 'not-started';
    let settled = null;
    const timeoutMs = deps.timeoutMs ?? 3000;
    function applyResponse(response) {
        if (!response.rightsChanged) {
            state = 'succeeded';
            return Promise.resolve();
        }
        return deps.keycloak().updateToken(-1)
            .then(() => { state = 'succeeded'; })
            .catch((err) => {
            deps.logger.error('auth-bootstrap: force-refresh failed', err);
            state = 'failed';
        });
    }
    function runCall(applyBudget) {
        const controller = applyBudget ? new AbortController() : null;
        let timer = null;
        const callPromise = deps.postBootstrap(controller ? { signal: controller.signal } : undefined);
        const racingPromise = applyBudget && controller
            ? new Promise((resolve, reject) => {
                timer = setTimeout(() => {
                    controller.abort();
                    reject(new Error(`auth-bootstrap: timed out after ${timeoutMs}ms`));
                }, timeoutMs);
                callPromise.then(resolve, reject);
            })
            : callPromise;
        return racingPromise
            .then(applyResponse)
            .catch((err) => {
            deps.logger.error('auth-bootstrap: call failed', err);
            state = 'failed';
        })
            .finally(() => {
            if (timer !== null)
                clearTimeout(timer);
        });
    }
    return {
        start() {
            if (state !== 'not-started')
                return;
            state = 'pending';
            settled = runCall(/* applyBudget */ true);
        },
        awaitInitial() {
            return settled ?? Promise.resolve();
        },
        async recover() {
            // Idempotent path: ignore the timeout budget, drive a fresh call.
            try {
                await runCall(/* applyBudget */ false);
            }
            catch {
                // runCall swallows its own errors and sets state.
            }
        },
        getState() {
            return state;
        },
    };
}
